// @ts-ignore -- This entry will only be included if we detect that
// `@nerdwallet/sentry` is installed in the project being built.
// eslint-disable-next-line import/no-unresolved
import { initSentryBrowser } from '@nerdwallet/sentry';
initSentryBrowser();